const quality = "q_20";
let data = [
  {
    img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1684081578/portfolioAssets/certeficates/dl_andrewNG_xbfm3n.png`,
  },
  {
    img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1681448405/portfolioAssets/certeficates/mlAndrewNg_ffvhq7.png`,
  },
  {
    img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1681448399/portfolioAssets/certeficates/resPonsiveWebDesign_xmqbue.png`,
  },
  {
    img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1681448396/portfolioAssets/certeficates/imageProcessing_hjh4xq.png`,
  },
  {
    img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1681448386/portfolioAssets/certeficates/gameDev_pio7wx.png`,
  },
  {
    img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1681448388/portfolioAssets/certeficates/introMatplotLib_wqto5z.png`,
  },
  {
    img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1681448401/portfolioAssets/certeficates/programmingFoundation_av9lu6.png`,
  },
  {
    img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1681448407/portfolioAssets/certeficates/unsupervisedLearning_fzzomk.png`,
  },
  {
    img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1681448411/portfolioAssets/certeficates/superVisedSklearn_x3eree.png`,
  },
  {
    img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1682970318/portfolioAssets/certeficates/ts_analysis_vd55zu.png`,
  },
  {
    img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1684272419/portfolioAssets/certeficates/intro_nlp_ih3qhn.png`,
  },
];

export default data;
